import styled from 'styled-components';

export const ContainerCheck = styled.div`
  cursor: ${(props) => (props.hideCursor ? 'none' : 'pointer')};
  display: inline-flex;
  position: relative;
  justify-content: center;
  & label {
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 50%;
    height: ${(props) => (props.width ? props.width + 'px' : '20px')};
    left: 0;
    position: relative;
    top: 0;
    width: ${(props) => (props.width ? props.width + 'px' : '20px')};
  }

  & label:after {
    border: ${(props) => (props.width ? (props.width * 15) / 100 + 'px' : '2px')}
      solid #ffffff;
    border-top: none;
    border-right: none;
    content: '';
    height: ${(props) => (props.width ? (props.width * 45) / 100 + 'px' : '6px')};
    left: ${(props) => (props.width ? (props.width * 20) / 100 + 'px' : '4px')};
    opacity: 0;
    position: absolute;
    top: ${(props) => (props.width ? (props.width * 15) / 100 + 'pk' : '4px')};
    transform: rotate(-45deg);
    width: ${(props) => (props.width ? (props.width * 70) / 100 + 'px' : '12px')};
  }
  & input[type='checkbox'] {
    visibility: hidden;
  }

  & input[type='checkbox']:checked + label {
    background-color: #001871;
    border-color: #001871;
  }
  & input[type='checkbox']:checked + label:after {
    opacity: 1;
  }
`;
